var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.homeMenuPage },
    [
      _vm.isAuthenticated && !_vm.isGuest && _vm.user
        ? _c("div", { class: _vm.$style.homePastOrder }, [
            _c(
              "button",
              {
                class: _vm.$style.pastOrderBtn,
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.togglePastOrders(true)
                  }
                }
              },
              [
                _c("span", { class: _vm.$style.pastOrderImage }, [
                  _c("svg", {
                    directives: [{ name: "svg", rawName: "v-svg" }],
                    class: _vm.$style.pastOrderIcon,
                    attrs: { symbol: "past-order" }
                  })
                ]),
                _vm._v("\n      Past Order\n    ")
              ]
            ),
            _vm._v(" "),
            _c("div", { class: _vm.$style.homePastTitle }, [
              _c("h5", [_vm._v("Look at past orders")]),
              _vm._v(" "),
              _c("svg", {
                directives: [{ name: "svg", rawName: "v-svg" }],
                class: _vm.$style.curvedArrowUp,
                attrs: { symbol: "curved-arrow" }
              })
            ])
          ])
        : _c("div", { class: _vm.$style.claimAccountSection }, [
            _c("div", { class: _vm.$style.homeMenuContainer }, [
              _c(
                "div",
                { class: _vm.$style.claimAccount },
                [
                  _c("div", { class: _vm.$style.claimAccountLogo }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/img/white.png"),
                        alt: "Burger Boss"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { class: _vm.$style.claimAccountText }, [
                    _c("div", { class: _vm.$style.claimAccountTitle }, [
                      _c("h2", [_vm._v("Saved orders at one of our Kiosks? ")]),
                      _vm._v(" "),
                      _c("span", { class: _vm.$style.newLabel }, [
                        _vm._v("New")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { class: _vm.$style.claimAccountInfo }, [
                      _c("h6", [_vm._v("Look up your last 5 orders!")]),
                      _vm._v(" "),
                      _c("span")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "BaseButton",
                    {
                      class: _vm.$style.claimAccountBtn,
                      attrs: { "button-style": "Main" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.claimAccount($event)
                        }
                      }
                    },
                    [_vm._v("\n          Claim Account\n        ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { class: _vm.$style.homePastTitle }, [
                _c("h5", [_vm._v("Look at past orders")]),
                _vm._v(" "),
                _c("svg", {
                  directives: [{ name: "svg", rawName: "v-svg" }],
                  class: _vm.$style.curvedArrowUp,
                  attrs: { symbol: "curved-arrow" }
                })
              ])
            ])
          ]),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.$style.homeMenuCenter },
        [_c("Logo", { class: _vm.$style.homeMenuLogo })],
        1
      ),
      _vm._v(" "),
      _c("div", { class: _vm.$style.homeMenuMain }, [
        _c("div", { class: _vm.$style.homeMenuContainer }, [
          _c("div", { class: _vm.$style.homeStartTitle }, [
            _c("h5", [_vm._v("Start a new order")]),
            _vm._v(" "),
            _c("svg", {
              directives: [{ name: "svg", rawName: "v-svg" }],
              class: _vm.$style.curvedArrowDown,
              attrs: { symbol: "curved-arrow" }
            })
          ]),
          _vm._v(" "),
          _c("h2", { class: _vm.$style.homeMenuTitle }, [
            _c("span", [_vm._v("Our Menu")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { class: _vm.$style.homeMenuButtons },
            [
              _c(
                "BaseButton",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isGuest,
                      expression: "!isGuest"
                    }
                  ],
                  class: _vm.$style.pastOrdersMobile,
                  attrs: { "button-style": "Alpha" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.togglePastOrders(true)
                    }
                  }
                },
                [
                  _c("h6", [_vm._v("Look up my past orders")]),
                  _vm._v(" "),
                  _c("p", [_vm._v("Up to last 5 orders")])
                ]
              ),
              _vm._v(" "),
              _vm._l(_vm.sortedProducts, function(product) {
                return [
                  _c(
                    "BaseButton",
                    {
                      key: product.key,
                      class: _vm.$style.homeMenuBtn,
                      attrs: { "button-style": "Alpha" },
                      on: {
                        click: function($event) {
                          return _vm.openConfigurator(product.key)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " + _vm._s(product.name) + "\n          "
                      )
                    ]
                  )
                ]
              })
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _vm.pastOrdersDrawer || _vm.kioskPastOrdersOpen
        ? _c("PastOrders", {
            attrs: { value: _vm.pastOrdersDrawer || _vm.kioskPastOrdersOpen },
            on: {
              closeDrawer: function($event) {
                return _vm.togglePastOrders(false)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.menuIsLoading
        ? _c("LoadingSpinner", { attrs: { fixed: "" } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/desktop/components/DesktopMenu.vue?vue&type=template&id=f9b8596e&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&
// module id = null
// module chunks = 